import { useMemo } from 'react';
import { List, ListItemButton, ListItemText, ListItemAvatar, Avatar, Typography } from '@mui/material';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

export const NotificationList = () => {
  const groupByType = (array = []) => {
    const list = array || [];
    return list.reduce((results, currentValue) => {
      const type = currentValue?.type;

      function addGroup() {
        results.push({
          type,
          notifications: [],
        });
      }

      let index = results.findIndex((item) => item.type === type);
      if (index < 0) {
        addGroup();
      }

      index = results.findIndex((item) => item.type === type);
      if (index >= 0) {
        results[index].notifications.push(currentValue);
      }

      return results;
    }, []);
  };

  const notifications = useMemo(
    () => [
      {
        name: 'Sandra Adams',
        message: 'Harry Wilson created a job on 01 Jacksonville Street, Ryde',
        date: '3 mins ago - Today',
        type: 'Today',
        visited: false,
      },
      {
        name: 'Travis Howard',
        message: 'Harry Wilson added a product on 01 Jacksonville Street, Ryde',
        date: 'Friday, April 7 2023, 4:01 PM',
        type: 'Older',
        visited: false,
      },
      {
        name: 'Cindy Baker',
        message: '01 Jacksonville Street, Ryde is now ready to be booked',
        date: '3 mins ago - Today',
        type: 'Today',
        visited: true,
      },
      {
        name: 'John Simmons',
        message: 'Your images for 01 Jacksonville Street, Ryde are ready for proofing',
        date: 'Friday, April 7 2023, 4:30 PM',
        type: 'Older',
        visited: true,
      },
      {
        name: 'John Simmons',
        message: 'Your images for 01 Jacksonville Street, Ryde are ready for selection',
        date: 'Friday, April 8 2023, 4:30 PM',
        type: 'Older',
        visited: true,
      },
    ],
    []
  );

  const groupedNotifications = useMemo(() => groupByType(notifications), [notifications]);

  return (
    <>
      {groupedNotifications.map((group, groupIndex) => {
        return (
          <div key={groupIndex}>
            <Typography sx={{ fontWeight: 500, fontSize: '14px', px: 2, pt: groupIndex === 0 ? 2 : 1 }}>
              {group.type}
            </Typography>
            <List sx={{ width: '100%', maxWidth: '340px', bgcolor: 'background.paper', pb: 0 }}>
              {group.notifications.map((item, index) => {
                return (
                  <ListItemButton
                    key={index}
                    alignItems="center"
                    sx={{ opacity: item.visited ? '50%' : '100%' }}
                  >
                    <ListItemAvatar>
                      <Avatar
                        alt={item.name}
                        src="/static/images/avatar/1.jpg"
                        sx={{ backgroundColor: 'primary.main' }}
                      />
                    </ListItemAvatar>
                    <ListItemText
                      primary={
                        <Typography
                          sx={{ fontSize: '13px', lineHeight: 1.1 }}
                          component="p"
                          variant="body2"
                          color="text.primary"
                        >
                          {item.message}
                        </Typography>
                      }
                      secondary={
                        <Typography
                          sx={{ fontSize: '11px', pt: 0.2, fontWeight: 300 }}
                          component="p"
                          variant="body2"
                          color="text.primary"
                        >
                          {item.date}
                        </Typography>
                      }
                    />
                    {!item.visited ? (
                      <FiberManualRecordIcon
                        sx={{ color: 'primary.main', alignSelf: 'start', width: '0.8em', height: '0.8em' }}
                      />
                    ) : (
                      ''
                    )}
                  </ListItemButton>
                );
              })}
            </List>
          </div>
        );
      })}
    </>
  );
};
